module.exports = __webpack_public_path__ + "img/award.72075ce0.jpg";